import { useState, useCallback } from 'react';
import Toast from './Toast';

interface UseToastReturn {
  showToast: (message: string) => void;
  ToastComponent: React.FC;
}

const useToast = (): UseToastReturn => {
  const [message, setMessage] = useState<string | null>(null);

  const showToast = useCallback((msg: string) => {
    setMessage(msg);
    setTimeout(() => setMessage(null), 5000);
  }, []);

  const ToastComponent: React.FC = () => (
    message ? <Toast message={message} /> : null
  );

  return { showToast, ToastComponent };
};

export default useToast;
